import React, { useState } from "react";

function CollapsibleCardContainer({
  title,
  children,
  defaultOpen = true,
  style = {},
  gap = "24px",
  mode = "popup", // Default to 'page' mode if not provided
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  // 1. Define configuration settings for each mode
  const modeStyles = {
    popup: {
      titleColor: "#9CA3AF",
      titleSize: "12px",
      arrowIcon: "arrow_down_blue_medium.svg",
      textTransform: "uppercase",
    },
    page: {
      titleColor: "#1a2127",
      titleSize: "1.17rem",
      arrowIcon: "arrow_down_blue_medium.svg",
      textTransform: "capitalize",
    },
  };

  // 2. Fallback safely to 'page' mode if an invalid mode is passed
  const currentMode = modeStyles[mode] || modeStyles.page;

  return (
    <div
      className={`collapsive-accordion-container mode-${mode}`}
      style={{
        ...style,
        padding: currentMode.containerPadding, // Apply mode-specific padding
        gap: isOpen ? gap : "0px",
        transition: "gap 0.2s ease-in-out, padding 0.2s ease-in-out",
      }}
    >
      {/* Interactive Header */}
      <div
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <h4
          style={{
            margin: 0,
            fontSize: currentMode.titleSize,
            color: currentMode.titleColor,
            textTransform: currentMode.textTransform,
            letterSpacing: "1px",
          }}
        >
          {title}
        </h4>
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${currentMode.arrowIcon}`}
          alt={isOpen ? "Collapse section" : "Expand section"}
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out",
            width: "24px",
            height: "24px",
          }}
        />
      </div>

      {/* Collapsible Content Wrapper */}
      {isOpen && (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: gap,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleCardContainer;
